module.exports = __webpack_public_path__ + "img/tip.6fb37951.png";